import { Theme } from "baseui";
import { GiValve } from "react-icons/gi";
import { IoHandRightOutline } from "react-icons/io5";
import { MdOutlineSensorsOff } from "react-icons/md";
import { VscFoldUp, VscKey, VscWarning, VscCheck, VscSymbolEvent, VscFoldDown, VscReplace, VscDebugDisconnect, VscExclude } from 'react-icons/vsc'
import { FireDamper } from "../../Icons/FireDamper";
import { MotorIcon } from "../../Icons/MotorIcon";
import { IconEdgeDevice } from "../BacnetExplorer/IconEdgeDevice";


export interface AlarmClassStyle {
    backgroundColor: string,
    color: string,
    icon: React.ReactElement
}

export function getAlarmClassStyle(className: string, isOff: boolean, theme: Theme) : AlarmClassStyle | undefined {
    const iconsize = theme.sizing.scale800;
    if ( className === 'OutOfService' || className === 'AlarmNotValid' || className === 'AlarmNoFeedback')
    return {
        backgroundColor: isOff ? theme.colors.backgroundTertiary : theme.colors.backgroundWarningLight,
        color: theme.colors.warning500,
        icon: <MdOutlineSensorsOff size={iconsize}/>
    }

    if ( className === 'AlarmValve')
    return {
        backgroundColor: isOff ? theme.colors.backgroundTertiary : theme.colors.backgroundWarningLight,
        color: theme.colors.warning500,
        icon: <GiValve size={iconsize}/>
    }

    if ( className === 'AlarmDrive')
    return {
        backgroundColor: isOff ? theme.colors.backgroundTertiary : theme.colors.backgroundWarningLight,
        color: theme.colors.warning500,
        icon: <MotorIcon width={iconsize} color={theme.colors.warning500}/>
    }

    if ( className === 'AlarmLimitHeigh' || className === 'AlarmHeigh' )
    return {
        backgroundColor: 'transparent',
        color: theme.colors.negative,
        icon: <VscFoldUp size={iconsize}/>
    }
    if ( className === 'AlarmLow' || className === 'AlarmLimitLow')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.negative,
        icon: <VscFoldDown size={iconsize}/>
    }
    
    if ( className === 'CommonAlarm' || className === 'Alarm')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.negative,
        icon: <VscSymbolEvent size={iconsize}/>
    }

    if ( className === 'ManualMode')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.accent500,
        icon: <IoHandRightOutline size={iconsize}/>
    }
    if ( className === 'LocalOperation')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.positive500,
        icon: <VscKey size={iconsize}/>
    }
    if ( className === 'Acknowledge')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.positive500,
        icon: <VscCheck size={iconsize}/>
    }


    if ( className === 'WarningLimitLow')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.negative500,
        icon: <VscFoldDown size={iconsize}/>
    }

    if ( className === 'WarningLimitHeigh')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.negative500,
        icon: <VscFoldUp size={iconsize}/>
    }

    if ( className === 'Overridden')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.accent500,
        icon: <VscReplace size={iconsize}/>
    }
    
    if ( className === 'ErrorDamper')
    return {
        backgroundColor: isOff ? theme.colors.backgroundTertiary : theme.colors.backgroundWarningLight,
        color: theme.colors.warning500,
        icon: <FireDamper width={iconsize} color={theme.colors.warning500}/>
    }

    if ( className === 'AlarmDamper')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.negative500,
        icon: <FireDamper width={iconsize} color={theme.colors.negative500}/>
    } 

    
    if ( className === 'NoConnection')
    return {
        backgroundColor: isOff ? theme.colors.backgroundTertiary : theme.colors.backgroundWarningLight,
        color: theme.colors.warning600,
        icon: <IconEdgeDevice width={iconsize} height={iconsize} color={theme.colors.warning600}/>
    } 

    if ( className === 'Configuration')
    return {
        backgroundColor: 'transparent',
        color: theme.colors.warning500,
        icon: <VscExclude size={iconsize} />
    }
    if ( className === 'Fault')
    return {
        backgroundColor: isOff ? theme.colors.backgroundTertiary  : 'transparent',
        color: theme.colors.warning500,
        icon: <VscWarning size={iconsize} color={theme.colors.warning500}/>
    } 
    return {
        backgroundColor: 'transparent',
        color: theme.colors.negative500,
        icon: <VscWarning size={iconsize}/>
    }  
}